<script>
export default {
  name: 'Card',
  props: ['name','localisation','_id','active'],
}
</script>


<template>
  <div class="card">
    <figure  v-on:click="$emit('clicked-link')">
      <slot name="figure">
        <img src="../../assets/projetIcon.png">
      </slot>
    </figure>
    <header>
      <slot name="header">
        <div class="title" v-on:click="$emit('clicked-link')"> {{name}} </div>
        <div class="subTitle"> {{localisation}}</div>
        <div class="icons">
          <!-- <div class="icons-line" v-on:click="$emit('clicked-delete')">
            <div class="material-icons">delete_outline</div>
            <label>Supprimer le projet</label>
          </div> -->
          <div class="icons-line" v-if="active" v-on:click="$emit('clicked-over')">
            <div class="material-icons">not_interested</div>
            <label>Cloturer le projet</label>
          </div>
          <div class="icons-line" v-else v-on:click="$emit('clicked-over')">
            <div class="material-icons">radio_button_unchecked</div>
            <label>Réouvir le projet</label>
          </div>
        </div>
      </slot>
    </header>
    <body>
      <slot name="body">

      </slot>
    </body>
    <footer>
      <slot name="footer">
        <!-- <span v-on:click="$emit('clicked-over')" class="material-icons">swap_vert</span> -->
        <!-- <span  v-on:click="$emit('clicked-delete')" class="material-icons">delete_outline</span> -->
      </slot>
    </footer>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.card{
  @include myBlock;
  display: flex;
  padding: 0 10px 0 0px;
  height: 75px;
  
  & figure{
    margin: 0 10px 0 0;
    cursor: pointer;
    // border: red solid 1px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    width: 150px;
    flex: 0 0 auto;

    & img{
      // width: 150px;
      height: 100%;
    }
  }

  & header{
    // width: 240px;
    overflow: hidden;

    & .title{
      @include myFont;
      @include monoline;
      cursor: pointer;
      font-weight: 600;
      color: $main;
      margin: 8px 0 3px 0;
    }

    & .subTitle{
      @include myFont;
      @include monoline;
      font-size: 12px;
    }

    & .icons{
      display: flex;
      margin: 4px 0 0 0;

      &-line{
        display: flex;
        cursor: pointer;
        margin: 0 10px 0 0;

        &:hover{
          & label{
            color: $color2;
          }

          & .material-icons{
            color: $color2;
          }
        }
     
        & label{
          @include myFont;
          font-size: 10px;
          margin: 5px 0 0 2px;
          cursor: pointer;
        }

        & .material-icons{
          font-size: 16px;
          margin: 3px 0 0 -2px;
        }
      }
    }
  }

  & body{
    flex: 1;
    padding: 0 0px 0 0px;
    margin: 0 0 0px 0;
  }

  & footer{
    display: flex;
    align-items: center;
    color: $black-bolder;

    & span:hover{
      color: $color2;
      cursor: pointer;
    }

  }

}

</style>
